/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CopyToClipboard } from "react-copy-to-clipboard";
import { Link } from "react-router-dom";
import { FlexContainer, SVGIcon, Text, theme } from "@nordcloud/gnui";
import { ExternalLinkWithIndicator } from "~/components";
import { SUCCESS_TEXT } from "~/constants";
import { getProviderTooltip } from "~/hooks/useConsoleUrl/utils";
import { showSimpleInfo } from "~/services/toast";
import { isNotEmpty, trimTextBeginning } from "~/tools";

type Props = {
  id: string;
  type?: string;
  category?: string;
  nordcloudId: string;
  name: string;
  url?: string;
  provider: string;
};

export function ResourceNameCell({
  id,
  type,
  category,
  name,
  nordcloudId,
  url,
  provider,
}: Props) {
  const resourceName = isNotEmpty(name) ? name : id;
  const caption = getProviderTooltip(provider);
  return (
    <>
      <FlexContainer>
        <Link
          to={`/estate/${nordcloudId}`}
          title={resourceName}
          css={{
            whiteSpace: "nowrap",
          }}
        >
          {trimTextBeginning(resourceName, 30)}
        </Link>
        <CopyToClipboard
          text={resourceName}
          onCopy={() => {
            showSimpleInfo(SUCCESS_TEXT.copied);
          }}
        >
          <SVGIcon
            name="copy"
            size="sm"
            style={{
              cursor: "pointer",
              marginLeft: theme.spacing.spacing02,
            }}
          />
        </CopyToClipboard>
        {url && (
          <ExternalLinkWithIndicator
            css={{ marginLeft: theme.spacing.spacing02 }}
            url={url}
            caption={caption}
          />
        )}
      </FlexContainer>
      <FlexContainer>
        {category && (
          <Text
            size="sm"
            tag="span"
            mr={theme.spacing.spacing01}
            weight="medium"
            color={theme.color.text.text02}
          >
            {category}:
          </Text>
        )}
        <Text size="sm" tag="span" color={theme.color.text.text02}>
          {type}
        </Text>
      </FlexContainer>
    </>
  );
}
